import { customElement, property, state } from 'lit/decorators.js';
import { SuperElement } from '../../internals/super/SuperElement';
import { html } from 'lit';
import { ratingStyles } from './Rating.styles';
import './element/RatingElement.component';
import type { RatingElement } from './element/RatingElement.component';
import { classMap } from 'lit/directives/class-map.js';

@customElement('lr-rating')
export class Rating extends SuperElement {
    static formAssociated = true;

    @property({ type: String })
    private size: RatingElement['size'] = 'medium';

    @property({ type: Number })
    value = 0;

    @property({ type: Boolean })
    submitOnChange = false;

    @state()
    hoveredRating: number | null = null;

    private internals: ElementInternals;

    static styles = [SuperElement.styles, ratingStyles];

    constructor() {
        super();
        this.internals = this.attachInternals();
    }

    private setRating(rating: number) {
        if (this.submitOnChange) {
            this.internals.setFormValue(rating.toString());
            this.internals.form?.requestSubmit();
        }
    }

    formAssociatedCallback() {
        this.internals.setFormValue(this.value.toString());
    }

    formResetCallback() {
        this.value = 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formStateRestoreCallback(state: any) {
        this.value = state;
    }

    renderElement() {
        const classes = classMap({
            disabled: this.value > 0
        });
        return html`
            ${[...Array(5)].map(
                (_, index) => html`
                    <lr-rating-element
                        size=${this.size}
                        class="${classes}"
                        .active=${index + 1 <= this.value ||
                        (this.value === 0 && index + 1 <= (this.hoveredRating ?? this.value))}
                        @click="${() => this.setRating(index + 1)}"
                        @mouseover="${() => {
                            this.hoveredRating = index + 1;
                        }}"
                        @mouseout="${() => {
                            this.hoveredRating = null;
                        }}"
                    />
                `
            )}
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-rating': Rating;
    }
}
